<template>
  <div class="page-wrapper">

    <div class="new-item-form" style="padding-top:10px;" v-if="editItem != false">
      <div class="scroll-container" style="padding-top:10px;">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <img src="@/assets/images/logo.gif" height="50px"/>
            </div>
          </div>
        </div>
        <div class="container view-with-bottom-menu">
          <div class="row">
            <div class="col-12 text-left" style="margin-top:10px;">
              <h2 v-if="editItem.id == 0">송장 등록</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4" style="margin-bottom: 20px;">
              <div class="card">
                <div class="card-header text-left">
                  <h4>보내는사람</h4>
                </div>
                <div class="card-body">
                  <div class="container">
<!--                    <div class="form-group row">-->
<!--                      <div class="col-4">업체</div>-->
<!--                      <div class="col-8">-->
<!--                        <select class="form-control" v-model="editItem.customer_id" @change="senderSelected()">-->
<!--                          <option value="0">직접입력</option>-->
<!--                          <option v-for="(customer, index) in customers" :value="customer.id">-->
<!--                            [{{customer.code}}]{{customer.title}}-->
<!--                          </option>-->
<!--                        </select>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="form-group row">-->
<!--                      <div class="col-4">업체코드</div>-->
<!--                      <div class="col-8">-->
<!--                        <input type="text" class="form-control" v-model="editItem.code"/>-->
<!--                      </div>-->
<!--                    </div>-->
                    <div class="form-group row">
                      <div class="col-4">보내는사람 *</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.sender"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">이메일 *</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.sender_email"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">Address 1</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.sender_address_1"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">Address 2</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.sender_address_2"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">POST CODE</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.sender_post_code"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">CONTACT</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.sender_contact"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-4" style="margin-bottom: 20px;">
              <div class="card">
                <div class="card-header text-left">
                  <h4>배송정보</h4>
                </div>
                <div class="card-body">
                  <div class="container">

                    <div class="form-group row">
                      <div class="col-4">배송일</div>
                      <div class="col-8">
                        <input type="date" class="form-control" v-model="editItem.dispatch_date"
                               v-on:change="verifySendDate()" placeholder="Date"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">CT (개수)</div>
                      <div class="col-8">
                        <input type="number" class="form-control" v-model="editItem.ct"/>
                      </div>
                    </div>
                    <div class="form-group row" style="display:none;">
                      <div class="col-4">화주종류</div>
                      <div class="col-8">
                        <select class="form-control" v-model="editItem.seller_type">
                          <option value="2">회사</option>
                          <option value="1">개인</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row" style="display:none;">
                      <div class="col-4">통관종류</div>
                      <div class="col-8">
                        <select class="form-control" v-model="editItem.custom_type">
                          <option value="목">목록통관</option>
                          <option value="일">일반통관</option>
                          <option value="간">간이통관</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row" style="display:none;">
                      <div class="col-4">거래구분</div>
                      <div class="col-8">
                        <select class="form-control" v-model="editItem.trade_type">
                          <option value="A">전자상거래</option>
                          <option value="C">일반</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row" style="display:none;">
                      <div class="col-4">관세청구</div>
                      <div class="col-8">
                        <select class="form-control" v-model="editItem.who_pays_tax">
                          <option value="0">Default</option>
                          <option value="1">수취인</option>
                          <option value="2">발송인</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row" style="display:none;">
                      <div class="col-4">관세사비용청구</div>
                      <div class="col-8">
                        <select class="form-control" v-model="editItem.who_pays_inspection">
                          <option value="0">Default</option>
                          <option value="1">수취인</option>
                          <option value="2">발송인</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">배송메모</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.note"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">
                        VALUE(USD):
                      </div>
                      <div class="col-4">
                        <input type="number" class="form-control" v-model="editItem.value"
                               placeholder="Product Value in USD" disabled/>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4" style="margin-bottom: 20px;">
              <div class="card">
                <div class="card-header text-left">
                  <h4>받는사람</h4>
                </div>
                <div class="card-body">
                  <div class="container">

                    <div class="form-group row">
                      <div class="col-4">받는사람</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.receiver"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">통관번호</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.custom_number"/>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-4">우편번호</div>
                      <div class="col-4">
                        <input type="text" class="form-control" v-model="editItem.post_code"/>
                      </div>
                      <div class="col-4">
                        <input type="button" class="btn btn-primary" value="주소검색" v-on:click="findAddress()"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">주소</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.address_1"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">상세주소</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.address_2"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">주민번호</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.national_id"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">연락처</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.receiver_contact"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">이메일</div>
                      <div class="col-8">
                        <input type="text" class="form-control" v-model="editItem.email"/>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card" style="margin-top:10px;">
            <div class="card-header">
              <h4>물품 리스트</h4>
            </div>
            <div class="card-body">


              <div class="row">

                <div class="col-12 col-md-4 text-left"  v-for="(item, index) in editItem.list">
                  <div>
                    <div style="width: 100%;display: flex; height: 38px; line-height: 38px;">
                      <div style="width: 100px; height: 38px; line-height: 38px;">
                        상품명
                      </div>
                      <div style="width: calc(100% - 100px);">
                        <input type="text" class="form-control" v-model="item.product"
                               @input="item.product = $event.target.value.toUpperCase()"
                               @keyup="onProductEntered(index)"/>
                      </div>
                    </div>

                    <div style="width: 100%;display: flex; height: 38px; line-height: 38px;">
                      <div style="width: 100px; height: 38px; line-height: 38px;">
                        브랜드
                      </div>
                      <div style="width: calc(100% - 100px);">
                        <input type="text" class="form-control" v-model="item.brand"
                               @input="item.brand = $event.target.value.toUpperCase()"
                               @keyup="checkBrandSpecialKey(index)"/>
                      </div>
                    </div>
                    <div style="width: 100%;display: flex; height: 38px; line-height: 38px; display:none;">
                      <div style="width: 100px; height: 38px; line-height: 38px;">
                        원산지
                      </div>
                      <div style="width: calc(100% - 100px);">
                        <input type="text" class="form-control" v-model="item.origin_country"
                               @input="item.origin_country = $event.target.value.toUpperCase()"/>
                      </div>
                    </div>
                    <div style="width: 100%;display: flex; height: 38px; line-height: 38px; display:none;">
                      <div style="width: 100px; height: 38px; line-height: 38px;">
                        HS Code
                      </div>
                      <div style="width: calc(100% - 100px);">
                        <select class="form-control" v-model="item.hs_code">
                          <option value="-1">Select</option>
                          <option v-for="(code, index) in hsCodes" :value="code.val">({{code.val}}){{code.title}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div style="width: 100%;display: flex; height: 38px; line-height: 38px;">
                      <div style="width: 100px; height: 38px; line-height: 38px;">
                        수량
                      </div>
                      <div style="width: calc(100% - 100px);">
                        <input type="number" class="form-control" v-model="item.amount" @keypress="onlyNumber" pattern="[0-9]*" @keyup="calculateTotalValue"/>
                      </div>
                    </div>
                    <div style="width: 100%;display: flex; height: 38px; line-height: 38px;">
                      <div style="width: 100px; height: 38px; line-height: 38px;">
                        단가 (USD)
                      </div>
                      <div style="width: calc(100% - 100px);">
                        <input type="number" class="form-control" v-model="item.value" @keyup="calculateTotalValue"/>
                      </div>
                    </div>
                    <div style="width: 100%;display: flex; height: 38px; line-height: 38px;">
                      <div style="width: 100px; height: 38px; line-height: 38px;">
                        <strong>총</strong>
                      </div>
                      <div style="width: calc(100% - 100px);">
                        <strong>{{item.amount*item.value}} USD</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button type="button" class="btn btn-primary" v-on:click="onAddGood()">물품 추가</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card" style="margin-top:10px;">
            <div class="card-header">
              <h4>Size & Price</h4>
            </div>
            <div class="card-body">

              <div class="row">
                <div class="col-12 col-md-4">
                  <div class="container">
                    <div class="form-group row">
                      <div class="col-4">Width</div>
                      <div class="col-6">
                        <input type="number" class="form-control" v-model="editItem.volume_x"
                               v-on:change="onVolumeEntered()"/>
                      </div>
                      <div class="col-2">cm</div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">Height</div>
                      <div class="col-6">
                        <input type="number" class="form-control" v-model="editItem.volume_y"
                               v-on:change="onVolumeEntered()"/>
                      </div>
                      <div class="col-2">cm</div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">Depth</div>
                      <div class="col-6">
                        <input type="number" class="form-control" v-model="editItem.volume_z"
                               v-on:change="onVolumeEntered()"/>
                      </div>
                      <div class="col-2">cm</div>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-4">
                  <div class="container">
                    <div class="form-group row">
                      <div class="col-4">부피무게</div>
                      <div class="col-4">
                        <input type="number" class="form-control" v-model="editItem.volume_weight/100" disabled/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">실무게</div>
                      <div class="col-6">
                        <input type="number" class="form-control" v-model="editItem.measured_weight"
                               v-on:change="onVolumeEntered()"/>
                      </div>
                      <div class="col-2">Kg</div>
                    </div>
                    <div class="form-group row">
                      <div class="col-4">최종무게</div>
                      <div class="col-6">
                        <input type="number" class="form-control" v-model="editItem.weight/100" disabled/>
                      </div>
                      <div class="col-2">Kg</div>
                    </div>
                  </div>
                </div>


                <div class="col-12 col-md-4">
                  <div class="container">
                    <div class="form-group row">
                      <div class="col-4">기본요금</div>
                      <div class="col-6" style="padding-right:0;">
                        £{{(editItem.base_price/100.0).toFixed(2)}}
                      </div>

                    </div>
                    <div class="form-group row">
                      <div class="col-4">500g당 추가요금</div>
                      <div class="col-6" style="padding-right:0;">
                        £{{(editItem.add_price/100.0).toFixed(2)}}
                      </div>

                    </div>
                    <div class="form-group row">
                      <div class="col-4">최종요금</div>
                      <div class="col-8">
                        <h3>£{{(editItem.price/100).toFixed(2)}}</h3>
                      </div>
                    </div>
                  </div>
                </div>

              </div>


            </div>
          </div>

          <div class="row" style="margin-top:30px;">

            <div class="col-12">
              <div v-if="editItem.id == 0" class="bottom-button positive-btn" v-on:click="submitEditItem()">생성</div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-else>
      <div class="row">
        <div class="col-12">
          <img src="@/assets/images/logo.gif" height="50px"/>
        </div>
      </div>
      <div class="row" style="margin-top:50px;">
        <div class="col-12">
          {{message}}
        </div>
      </div>
    </div>

    <div id="finder-container" class="fullscreen-container">
      <div id="postcodeFinderLayer" class="center-container">
        <img src="//t1.daumcdn.net/postcode/resource/images/close.png" id="btnCloseLayer"
             style="cursor:pointer;position:absolute;right:-3px;top:-3px;z-index:1" v-on:click="closeAddressFinder()"
             alt="닫기 버튼"/>
      </div>
    </div>
    <v-dialog/>
    <transition name="dissolve">
      <div class="loading-progressView" v-if="isLoading==true">
        <div class="loading-center-container">
          <div class="loading-content-center">
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <p class="loading-message"> {{loadingMessage}}</p>
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
    import {millisToDate} from "../api/Utils";
    import moment from "moment";
    import axios from "axios";
    import {getDepotCode} from "../api/parcel";
    import {getPublicSender} from "../api/customer";

    export default {
        name: "ItemForm",
        data() {
          return{
            user:false,
            editItem:false,
            useLiquid: false,
            countries: [],
            hsCodes: [],
            isMobile: isFromMobile(),
            showAddressFinder: false,
            message:'',
            isLoading:false,
            loadingMessage:'',
          }
        },
        created() {
        },
        mounted() {
          this.getInfo()

        },
      watch: {
        'editItem.note': function (newVal, oldVal) {
          if(this.$data.editItem == false) {
            return;
          }
          if (newVal.includes('"') || newVal.includes("'")) {
            this.$data.editItem.note = newVal.replace(/[^a-zA-Z ]/g, "");
            this.showModal("에러", "특수문자는 사용할수 없숩니다");
          }
        },
        'editItem.receiver': function (newVal, oldVal) {
          if(this.$data.editItem == false) {
            return;
          }
          if (newVal.includes('"') || newVal.includes("'")) {
            this.$data.editItem.receiver = newVal.replace(/[^a-zA-Z ]/g, "");
            this.showModal("에러", "특수문자는 사용할수 없숩니다");
          }
        },
        'editItem.address_1': function (newVal, oldVal) {
          if(this.$data.editItem == false) {
            return;
          }
          if (newVal.includes('"') || newVal.includes("'")) {
            this.$data.editItem.address_1 = newVal.replace(/[^a-zA-Z ]/g, "");
            this.showModal("에러", "특수문자는 사용할수 없숩니다");
          }
        },
        'editItem.address_2': function (newVal, oldVal) {
          if(this.$data.editItem == false) {
            return;
          }
          if (newVal.includes('"') || newVal.includes("'")) {
            this.$data.editItem.address_2 = newVal.replace(/[^a-zA-Z ]/g, "");
            this.showModal("에러", "특수문자는 사용할수 없숩니다");
          }
        },
        'editItem.sender': function (newVal, oldVal) {
          if(this.$data.editItem == false) {
            return;
          }
          if (newVal.includes('"') || newVal.includes("'")) {
            this.$data.editItem.sender = newVal.replace(/[^a-zA-Z ]/g, "");
            this.showModal("에러", "특수문자는 사용할수 없숩니다");
          }
        },
        'editItem.sender_address_1': function (newVal, oldVal) {
          if(this.$data.editItem == false) {
            return;
          }
          if (newVal.includes('"') || newVal.includes("'")) {
            this.$data.editItem.sender_address_1 = newVal.replace(/[^a-zA-Z ]/g, "");
            this.showModal("에러", "특수문자는 사용할수 없숩니다");
          }
        },
        'editItem.sender_address_2': function (newVal, oldVal) {
          if(this.$data.editItem == false) {
            return;
          }
          if (newVal.includes('"') || newVal.includes("'")) {
            this.$data.editItem.sender_address_2 = newVal.replace(/[^a-zA-Z ]/g, "");
            this.showModal("에러", "특수문자는 사용할수 없숩니다");
          }
        },
      },
        methods:{
          getInfo: function() {
            let self = this;
            console.log("get info")
            getPublicSender()
            .then(function(data) {
              console.log("response");
              console.log(data);
              if(data.success === true) {
                self.$data.user = data.item;
                self.createNewItem();
                self.getSettingList();
              }
            })
            .catch(function(err) {

            })
          },
          showDialog: function(msg) {
            if(msg === null) {
              this.$data.isLoading = false;
              this.$data.loadingMessage = '';
              return;
            }
            this.$data.isLoading = true;
            this.$data.loadingMessage = msg;
          },
          formatPrice(value) {
            return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          },
          onlyNumber ($event) {
            //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

            console.log("key code " + keyCode);
            if (keyCode < 48 || keyCode > 57 || keyCode == 46) { // 46 is dot
              console.log("prevent");
              return $event.preventDefault();
            }
            console.log("not prevent");
          },
          customFormatter(date) {
            return moment(date).format('YYYY-MM-dd');
          },
          convertToUppercase: function (str) {
            console.log("Convert " + str + " to upperCase");
            str = str.toUpperCase();
            console.log("Converted " + str);
          },
          createNewItem: function() {
            let today = new Date();
            this.$data.editItem = {
              id: 0,
              customer_id: this.$data.user.id,
              code: 'LPOU',
              list: [
                {
                  product: '',
                  brand: '',
                  site_url: '',
                  amount: 0,
                  value: 0,
                  origin_country: '',
                  liquid: 0,
                },
              ],
              sender: '',
              sender_email:'',
              sender_post_code: '',
              sender_address_1: '',
              sender_address_2: '',
              sender_contact: '',
              receiver: '',
              receiver_contact: "",
              custom_number: "",
              who_pays_tax: 0,
              who_pays_inspection: 0,
              email: "",
              national_id: "",
              post_code: "",
              address_1: "",
              address_2: "",
              code_list:'',
              ct: 1,
              deliery_company_id: 0,
              value: 0,
              forwarder_id: 4,
              forwarder_string: "CWAY",
              dispatch_date: millisToDate(today.getTime(), '-'),
              "volume_x": 0,
              "volume_y": 0,
              "volume_z": 0,
              "volume_weight": 0,
              "measured_weight": 0,
              "weight": 0,
              "price": 0,
              base_price: this.$data.user.base_price,
              add_price: this.$data.user.price,
              "custom_type": "목",
              "trade_type": "A",
              "seller_type": 2,

            }
          },
          calculateTotalValue: function() {
            console.log("calculateValue");
            if(this.$data.editItem.list.length == 0) {
              this.$data.editItem.value = 0;
              return;
            }

            let totalValue = 0;
            for(let i = 0 ; i < this.$data.editItem.list.length ; i++) {
              if(this.$data.editItem.list[i].amount== "" || this.$data.editItem.list[i].value == '') {

                continue;
              }
              console.log(i + " item " + this.$data.editItem.list[i].amount + " " + this.$data.editItem.list[i].value);
              totalValue += (Number(this.$data.editItem.list[i].amount)*parseFloat(this.$data.editItem.list[i].value));
            }
            this.$data.editItem.value = totalValue;
            console.log("total Value = " + this.$data.editItem.value);
          },
          getSettingList: function () {
            var self = this;
            console.log("getForwarderList");
            var url = process.env.APP_URL + 'api/get_customer_meta.php?customer_id=0';
            axios.get(url)
              .then(response => {
                console.log(response);
                var data = response.data;
                if (data.success) {
                  self.$data.forwarders = data.forwarders;
                  console.log("forwarders set");
                  console.log(self.$data.forwarders);
                  self.$data.countries = data.countries;
                  self.$data.hsCodes = data.hs_code;
                }
              })
              .catch(error => {

              });
          },
          verifyItemForm: function () {
            if(this.$data.editItem.sender_email === null || this.$data.editItem.sender_email === '') {
              this.showModal("ERROR", "보내는 사람 이메일을 입력해주세요");
              return false;
            }
            if (this.$data.editItem.sender.length < 1) {
              this.showModal("ERROR", "보내는 사람을 입력해주세요");
              return false;
            }
            if (this.$data.editItem.code.length != 4) {
              this.showModal("ERROR", "보내는 사람을 입력해주세요");
              return false;
            }
            if (this.$data.editItem.sender_post_code.length < 5) {
              this.showModal("ERROR", "Post code Required");
              return false;
            }
            if (this.$data.editItem.sender_address_1.length < 1) {
              this.showModal("ERROR", "Address Required");
              return false;
            }
            if (this.$data.editItem.sender_address_2.length < 1) {
              this.showModal("ERROR", "Address Detail Required");
              return false;
            }
            if (this.$data.editItem.sender_contact.length < 1) {
              this.showModal("ERROR", "Sender Contact Required");
              return false;
            }
            if (this.$data.editItem.receiver.length < 2) {
              this.showModal("ERROR", "Name Required");
              return false;
            }
            if (this.$data.editItem.receiver_contact.length < 10) {
              this.showModal("ERROR", "Phone number Required");
              return false;
            }
            if (this.$data.editItem.post_code.length < 5) {
              this.showModal("ERROR", "Post code Required");
              return false;
            }
            if (this.$data.editItem.address_1.length < 1) {
              this.showModal("ERROR", "Address Required");
              return false;
            }
            // if(this.$data.editItem.address_2.length < 1) {
            //   this.showModal("ERROR", "Address Detail Required");
            //   return false;
            // }
            if (this.$data.editItem.value.length < 0) {
              this.showModal("ERROR", "Value Required");
              return false;
            }
            // if (this.$data.editItem.forwarder_id < 0) {
            //   this.showModal("ERROR", "Select Forwarder");
            //   return false;
            // }
            if (this.$data.editItem.dispatch_date.length == 0 || this.$data.editItem.dispatch_date == '0000-00-00') {
              this.showModal("ERROR", "Select Date to Send");
              return false;
            }

            return this.validateGoods();
          },
          getTodayData: function () {
            var myDate = new Date();
            var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
            var date = ('0' + myDate.getDate()).slice(-2);
            var year = myDate.getFullYear();
            var formattedDate = year + '-' + month + '-' + date;
            return formattedDate;
          },
          verifySendDate: function () {
            if (this.$data.editItem.dispatch_date.length == 0 || this.$data.editItem.dispatch_date == '0000-00-00') {
              this.showModal("ERROR", "보내는 날짜를 선택해주세요");
              return;
            }

            if (this.$data.editItem.dispatch_date < this.getTodayData()) {
              this.showModal("ERROR", "불가능한 날짜입니다.");
              this.$data.editItem.dispatch_date = '0000-00-00';
              return;
            }
          },
          validateGoods: function () {
            if (this.$data.editItem == false) {
              return false;
            }
            if (this.$data.editItem.list.length == 0) {
              this.showModal("ERROR", "물품을 추가해주세요");
              return false;
            }

            console.log(this.$data.editItem.list);

            for (let i = this.$data.editItem.list.length - 1; i >= 0; i--) {

              if (this.$data.editItem.list[i].amount == 0 && i >= 5) {
                this.$data.editItem.list.splice(i, 1);

              }
            }
            if (this.$data.editItem.list.length == 0) {
              this.showModal("ERROR", "물품을 추가해주세요");
              return false;
            }
            this.countTotalValue();
            return true;
          },
          countTotalValue: function () {
            if (this.$data.editItem == false) {
              return;
            }
            this.$data.editItem.value = 0;
            if (this.$data.editItem.list.length == 0) {
              return;
            }
            for (let i = 0; i < this.$data.editItem.list.length; i++) {
              this.$data.editItem.value += parseInt(this.$data.editItem.list[i].value) * parseInt(this.$data.editItem.list[i].amount);
            }

          },
          onProductEntered: function (index) {
            if (this.$data.editItem == false) {
              return;
            }
            if (this.$data.editItem.list.length < index) {
              return;
            }

            if (this.$data.editItem.list[index].product.length > 0) {
              if (this.$data.editItem.list[index].amount == 0) {
                this.$data.editItem.list[index].amount = 1;
              }
            } else {
              this.$data.editItem.list[index].amount = 0;
            }
            if (this.$data.editItem.list[index].product.length > 0) {
              if (this.$data.editItem.list[index].product.includes('"') || this.$data.editItem.list[index].product.includes("'")) {
                this.showModal("에러", "특수문자는 사용할수 없습니다");
                this.$data.editItem.list[index].product = this.$data.editItem.list[index].product.replace(/[^a-zA-Z ]/g, "");


              }
            }
          },
          checkBrandSpecialKey: function (index) {
            if (this.$data.editItem == false) {
              return;
            }
            if (this.$data.editItem.list.length < index) {
              return;
            }
            if (this.$data.editItem.list[index].brand.length > 0) {
              if (this.$data.editItem.list[index].brand.includes('"') || this.$data.editItem.list[index].brand.includes("'")) {
                this.$data.editItem.list[index].brand = this.$data.editItem.list[index].brand.replace(/[^a-zA-Z ]/g, "");
                //this.$data.newItem.list[index].brand.replace('"', "");
                this.showModal("에러", "특수문자는 사용할수 없습니다");


              }
            }
          },
          findAddress: function () {
            this.$data.showAddressFinder = true;
            var self = this;
            new daum.Postcode({
              oncomplete: function (data) {
                // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

                // 각 주소의 노출 규칙에 따라 주소를 조합한다.
                // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
                var addr = ''; // 주소 변수
                var extraAddr = ''; // 참고항목 변수

                //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
                if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                  addr = data.roadAddress;
                } else { // 사용자가 지번 주소를 선택했을 경우(J)
                  addr = data.jibunAddress;
                }

                // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
                if (data.userSelectedType === 'R') {
                  // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                  // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                  if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
                    extraAddr += data.bname;
                  }
                  // 건물명이 있고, 공동주택일 경우 추가한다.
                  if (data.buildingName !== '') {
                    extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
                  }
                  // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                  if (extraAddr !== '') {
                    extraAddr = ' (' + extraAddr + ')';
                  }
                  // 조합된 참고항목을 해당 필드에 넣는다.
                  //document.getElementById("sample2_extraAddress").value = extraAddr;

                } else {
                  //document.getElementById("sample2_extraAddress").value = '';
                }

                // 우편번호와 주소 정보를 해당 필드에 넣는다.
                self.$data.editItem.post_code = data.zonecode;
                self.$data.editItem.address_1 = addr;

                if (extraAddr !== '') {
                  self.$data.editItem.address_1 += extraAddr;
                }
                self.$data.showAddressFinder = false;
                $("#finder-container").css('display', 'none');
                $("#postcodeFinderLayer").css('display', 'none');

              },
              width: '100%',
              height: '100%',
              maxSuggestItems: 5
            }).embed(document.getElementById('postcodeFinderLayer'));

            // iframe을 넣은 element를 보이게 한다.
            $("#finder-container").css('display', 'block');
            $("#postcodeFinderLayer").css('display', 'block');
          },
          closeAddressFinder: function () {
            console.log("close address finder");
            this.$data.showAddressFinder = false;
            $("#finder-container").css('display', 'none');
            $("#postcodeFinderLayer").css('display', 'none');
          },
          onVolumeEntered: function () {
            this.$data.editItem.volume_weight = this.$data.editItem.volume_x * this.$data.editItem.volume_y * this.$data.editItem.volume_z / 6000;
            this.$data.editItem.volume_weight = parseFloat(this.$data.editItem.volume_weight).toFixed(2)*100;
            console.log("Scaled Weight " + this.$data.editItem.measured_weight);
            console.log("Volume Weight " + this.$data.editItem.volume_weight);
            this.$data.editItem.weight = this.$data.editItem.volume_weight > this.$data.editItem.measured_weight*100 ? this.$data.editItem.volume_weight : this.$data.editItem.measured_weight*100;
            console.log("Weight " + this.$data.editItem.weight);
            if (this.$data.editItem.weight <= 100) {
              this.$data.editItem.price = this.$data.editItem.base_price;
            } else {
              var extra = this.$data.editItem.weight - 100;
              var extraUnit = parseInt(extra / 50);
              if (extra % 50 >= 10) {
                extraUnit += 1;
              }
              console.log("extra " + extraUnit);
              this.$data.editItem.price = Number(this.$data.editItem.base_price) + Number(extraUnit) * Number(this.$data.editItem.add_price);
            }

          },
          submitEditItem: function () {
            console.log("submitNewItem");
            if (this.verifyItemForm() == false) {
              return;
            }
            let item = {
              "customer_id": this.$data.editItem.customer_id,
              "sender": this.$data.editItem.sender,
              "code": this.$data.editItem.code,
              "sender_address_1": this.$data.editItem.sender_address_1,
              "sender_address_2": this.$data.editItem.sender_address_2,
              "sender_post_code": this.$data.editItem.sender_post_code,
              "sender_contact": this.$data.editItem.sender_contact,
              "sender_email": this.$data.editItem.sender_email,
              "dispatch_date": this.$data.editItem.dispatch_date,
              "receiver": this.$data.editItem.receiver,
              "receiver_contact": this.$data.editItem.receiver_contact,
              "email": this.$data.editItem.email,
              "post_code": this.$data.editItem.post_code,
              "address_1": this.$data.editItem.address_1,
              "address_2": this.$data.editItem.address_2,
              "ct": this.$data.editItem.ct,
              "value": this.$data.editItem.value,
              "volume_x": this.$data.editItem.volume_x,
              "volume_y": this.$data.editItem.volume_y,
              "volume_z": this.$data.editItem.volume_z,
              "volume_weight": this.$data.editItem.volume_weight,
              "measured_weight": this.$data.editItem.measured_weight*100,
              "weight": this.$data.editItem.weight,
              "price": this.$data.editItem.price,
              "base_price": this.$data.editItem.base_price,
              "add_price": this.$data.editItem.add_price,
              "forwarder_id": this.$data.editItem.forwarder_id,
              "forwarder_string": this.$data.editItem.forwarder_string,
              "custom_number": this.$data.editItem.custom_number,
              "who_pays_tax": this.$data.editItem.who_pays_tax,
              "who_pays_inspection": this.$data.editItem.who_pays_inspection,
              "national_id": this.$data.editItem.national_id,
              "list": JSON.stringify(this.$data.editItem.list),
              "custom_type": this.$data.editItem.custom_type,
              "trade_type": this.$data.editItem.trade_type,
              "seller_type": this.$data.editItem.seller_type,
              "note": this.$data.editItem.note,
              "code_list":"",
            };

            console.log(item);
            //return;
            let zipCode = item.post_code;
            if(zipCode.includes(" ")) {
              zipCode = zipCode.replace(" ", "");
            }
            let address = item.address_1;
            if (item.address_2.length > 0) {
              address += ' ' + item.address_2;
            }
            console.log("printItem zipCode = " + zipCode);
            console.log("printItem address = " + address);
            let self = this;
            this.$data.isLoading = true;
            this.showDialog("주소가져오는중입니다.");
            getDepotCode(zipCode, address)
              .then(function(dcdata) {
                self.showDialog(null);
                self.$data.isLoading = false;
                if (dcdata.cmmMsgHeader.successYN == 'Y') {

                  item.code_list = JSON.stringify(dcdata.delivAreaCdList);

                }
                self.postSubmitItem(item);
              })
              .catch(function(err) {
                self.showDialog(null);
                self.$data.isLoading = false;
                console.log("ERR to update " + err);
                if(err.response != undefined) {
                  console.log(err.response);
                }
                self.postSubmitItem(item);
              })

          },
          onAddGood: function () {
            let newGood = {
              product: "",
              brand: "",
              site_url: "",
              amount: 0,
              hs_code: -1,
              origin_country: "",
              value: 0,
              liquid: 0,
            };
            this.$data.editItem.list.push(newGood);
          },
          postSubmitItem: function(item) {
            let self = this;
            self.$data.isLoading = true;
            if (this.$data.editItem.id > 0) {
              item["id"] = this.$data.editItem.id;
              let postData = {
                "table": "item_table",
                "data": item,
              };
              axios.post(process.env.APP_URL + 'api/update.php', postData)
                .then(response => {
                  self.$data.isLoading = false;
                  console.log(response);
                  let data = response.data;
                  if (data.success == true) {
                    console.log("Successful update");

                    console.log("Set editItem to false");
                    self.$data.editItem = false;
                    self.$data.message = "송장 등록이 완료 되었습니다. 이메일을 확인해주세요. 접수확인되는데로 열락드리겠습니다.";
                  } else {
                    self.showModal("ERROR", "Failed to update " + data.message);
                  }
                })
                .catch(error => {
                  self.$data.isLoading = false;
                  self.showModal("ERROR", "죄송합니다. 생성 실패했습니다. " + error);
                })
            } else {
              self.showDialog("송장 생성중");
              axios.post(process.env.APP_URL + 'api/add_new_item.php', item)
                .then(response => {
                  self.$data.isLoading = false;
                  self.showDialog(null);
                  console.log(response);
                  let data = response.data;
                  if (data.success == true) {
                    data.item.list = JSON.parse(data.item.list);
                    self.$data.editItem = false;
                    self.$data.message = "송장 등록이 완료 되었습니다. 이메일을 확인해주세요. 접수확인되는데로 열락드리겠습니다.";
                  } else {
                    self.showModal("ERROR", "Failed to create new AWB " + data.message);
                  }
                })
                .catch(error => {
                  self.showDialog(null);
                  self.$data.isLoading = false;
                  self.showModal("ERROR", "죄송합니다. 생성 실패했습니다. " + error);
                })
            }
          },
          showModal: function (title, message) {
            console.log("show modal " + title + " : " + message);
            this.$modal.show('dialog', {
              title: title,
              text: message,
              buttons: [
                {title: 'Close'}
              ]
            })
            return;
          },
        }
    }
</script>

<style scoped>
  lds-roller {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-roller div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 40px 40px;
  }
  .lds-roller div:after {
    content: " ";
    display: block;
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #fff;
    margin: -4px 0 0 -4px;
  }
  .lds-roller div:nth-child(1) {
    animation-delay: -0.036s;
  }
  .lds-roller div:nth-child(1):after {
    top: 63px;
    left: 63px;
  }
  .lds-roller div:nth-child(2) {
    animation-delay: -0.072s;
  }
  .lds-roller div:nth-child(2):after {
    top: 68px;
    left: 56px;
  }
  .lds-roller div:nth-child(3) {
    animation-delay: -0.108s;
  }
  .lds-roller div:nth-child(3):after {
    top: 71px;
    left: 48px;
  }
  .lds-roller div:nth-child(4) {
    animation-delay: -0.144s;
  }
  .lds-roller div:nth-child(4):after {
    top: 72px;
    left: 40px;
  }
  .lds-roller div:nth-child(5) {
    animation-delay: -0.18s;
  }
  .lds-roller div:nth-child(5):after {
    top: 71px;
    left: 32px;
  }
  .lds-roller div:nth-child(6) {
    animation-delay: -0.216s;
  }
  .lds-roller div:nth-child(6):after {
    top: 68px;
    left: 24px;
  }
  .lds-roller div:nth-child(7) {
    animation-delay: -0.252s;
  }
  .lds-roller div:nth-child(7):after {
    top: 63px;
    left: 17px;
  }
  .lds-roller div:nth-child(8) {
    animation-delay: -0.288s;
  }
  .lds-roller div:nth-child(8):after {
    top: 56px;
    left: 12px;
  }
  @keyframes lds-roller {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .loading-progressView {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgb(0,0,0,0.7);
    z-index:99999;
  }
  .loading-center-container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 70px;
    height: 70px;
    transform: translate(-50%, -50%);
  }
  .loading-content-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/ItemForm.vue